<template lang="pug">
el-config-provider(:locale="elementPlusLanguage")
  SmxBaseLayout
    template(#navbar)
      Navbar(
        v-if="!isPublicPage",
        :post-logout="logoutCallback",
        title="",
        logo-path="/img/logo.png",
        logo-path-small="/img/logo-small.png",
        line-color="linear-gradient(90deg, #006cb5, #25b8cd)"
      )
    template(#menu)
      SmxMenu(v-if="!isPublicPage")
    .app-content(class="max-md:p-5 md:p-10")
      RouterView(:key="route.path")
</template>

<script setup lang="ts">
import { computed } from "vue";
import { RouterView, useRoute, useRouter } from "vue-router";
import Navbar from "@shared/components/Header.vue";
import { useI18n } from "vue-i18n";
import { publicPages } from "@shared/router/loginGuard";
import { useAuthStore } from "../../shared/src/stores/auth";
import { useAppStore } from "../../shared/src/stores/apps";
import de from "element-plus/dist/locale/de.mjs";
import en from "element-plus/dist/locale/de.mjs";
import SmxMenu from "@shared/components/SmxMenu.vue";
import { useMenuStore } from "../../shared/src/stores/menu";
import SmxBaseLayout from "@shared/views/SmxBaseLayout.vue";
import { useMyAccountStore } from "../../shared/src/stores/myAccount";
import { useKeyCloakAuthentication } from "../../shared/src/hooks/authentication";
import useMenu from "@shared/hooks/menu";

const myAccountStore = useMyAccountStore();
useKeyCloakAuthentication();
const { isPublicPage } = useMenu();
const elementPlusLanguage = computed(() => {
  switch (myAccountStore.language) {
    case "en":
      return en;
    default:
      return de;
  }
});

const appStore = useAppStore();
const menuStore = useMenuStore();
const router = useRouter();
const route = useRoute();

const logoutCallback = () => {
  router.push({ name: "login" });
};
</script>

<style>
body {
  max-width: 100vw;
  overflow-x: hidden;
}

.app-body {
  display: flex;
}

.app-content {
  width: 100%;
}

:root {
  --el-color-primary: #006cb5;
  --el-color-primary-light-3: #6e929f;
  --el-color-primary-light-5: #7bb6c6;
  --el-color-primary-light-7: #a2cfdb;
  --el-color-primary-light-8: #c0dee6;
  --el-color-primary-light-9: #eaf6f9;
  --el-color-primary-dark-2: #356977;
}
</style>
